import React from "react";
import TmsTranslate from "./components/TmsTranslate";
import {createRoot} from "react-dom/client";

let app;


export function init() {

    let tagList = document.querySelectorAll("tms-translate");
    const attribute = tagList.attributes;
    for (let i = 0; i < tagList.length; i++) {
        app = createRoot(tagList[i]);
        //@ts-ignore
        app.render(<TmsTranslate attribute={attribute}/>);
    }
}
